import React from "react";
import {
  comparisonSources,
  comparableHistory,
  comparisonMetrics,
  contextualMetrics,
} from "../helpers/teamWorkspace";
export default function LeagueComparisonMatrix({
  data,
  rows,
  venue,
  recent,
  perGame,
  en,
}) {
  const t = (d, e) => (en ? e : d),
    fmt = (n) =>
      typeof n === "number" && Number.isFinite(n)
        ? n.toLocaleString(en ? "en-GB" : "de-DE", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        : "—";
  const names = {
    "settings-result":t("Ergebnismodell · Settings · pro Spiel", "Results model · settings · per match"),
    "settings-statistics":t("Statistikmodell · Settings · pro Spiel", "Statistics model · settings · per match"),
    previous:t("Vorsaison", "Previous season"),
    real: t("Reale Ergebnisse", "Actual results"),
    should: "Should Goals",
    result: t("Ergebnismodell · erwartet", "Results model · expected"),
    statistics: t("Statistikmodell · erwartet", "Statistics model · expected"),
    market: t("Marktrückrechnung", "Market inversion"),
  };
  const fields = [
    ["goalsFor", t("Für", "For")],
    ["goalsAgainst", t("Gegen", "Against")],
    ["goalTotal", t("Torsumme", "Goal total")],
    ["goalDifference", t("Tordifferenz", "Goal difference")],
    ["quotient", t("Quotient", "Ratio")],
    ["wins", t("Siege", "Wins")],
    ["draws", t("Remis", "Draws")],
    ["losses", t("Niederlagen", "Losses")],
    ["points", t("Punkte", "Points")],
    ["winProbability", t("Sieg · Anteil", "Win · share")],
    ["drawProbability", t("Remis · Anteil", "Draw · share")],
    ["lossProbability", t("Niederlage · Anteil", "Loss · share")],
  ];
  return (
    <section>
      <h3>
        {t(
          "Alle verfügbaren Quellen und Kennzahlen",
          "All available sources and metrics"
        )}
      </h3>
      <p>
        {t(
          "Jede Zeile nennt ihre eigene Abdeckung. Für direkte Bewertungen die gemeinsame Spielmenge in der Teamansicht wählen. Anteile liegen zwischen 0 und 1; reale Anteile sind Häufigkeiten.",
          "Each row reports its own coverage. Use common matches in the team view for direct assessments. Shares range from 0 to 1; actual shares are observed frequencies."
        )}
      </p>
      <div className="tl-table">
        <table>
          <thead>
            <tr>
              <th>{t("Team", "Team")}</th>
              <th>{t("Quelle", "Source")}</th>
              <th>
                {t("Tore / Bilanz / Auswahl", "Goals / outcomes / selection")}
              </th>
              {fields.map(([k, l]) => (
                <th key={k}>{l}</th>
              ))}
              <th>
                {t(
                  "Faire Quote · 1/X/2 aus Teamsicht",
                  "Fair odds · W/D/L from team perspective"
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.flatMap((row) =>
              [...comparisonSources,"settings-result","settings-statistics","previous"].map((source) => {
                const pool = comparableHistory(
                    data.observations || [],
                    row.teamId,
                    [source],
                    { recent, venue: venue === "overall" ? "all" : venue }
                  ),
                  contextual=source==="previous" || source.startsWith("settings-"),
                  m = contextual ? contextualMetrics(data,row.teamId,source,venue === "overall" ? "all" : venue,source.startsWith("settings-") || perGame) : comparisonMetrics(pool.selected,row.teamId,source,perGame);
                return (
                  <tr key={`${row.teamId}:${source}`}>
                    <th>
                      {data.team_images?.[row.teamId] && (
                        <img src={data.team_images[row.teamId]} alt="" />
                      )}
                      {row.name}
                    </th>
                    <td>{names[source]}{m.period&&<small style={{display:"block"}}>{m.period}</small>}</td>
                    <td>
                      {m.count ?? "—"} / {m.outcomes?.count ?? (source==="previous"?m.count:"—")} /{" "}
                      {contextual?"—":pool.selected.length}
                    </td>
                    {fields.map(([k]) => (
                      <td key={k}>{fmt(m[k])}</td>
                    ))}
                    <td>
                      {["real","previous"].includes(source)
                        ? "—"
                        : [
                            "winProbability",
                            "drawProbability",
                            "lossProbability",
                          ]
                            .map((k) => fmt(m[k] > 0 ? 1 / m[k] : null))
                            .join(" / ")}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
